import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import pageTemplateAbout from './routes/about'
import locations from './routes/locations'
import blog from './routes/blog'
import archive from './routes/blog'
import pageTemplatePortfolio from './routes/projects'
import pageTemplateServices from './routes/services'
import singlePost from './routes/singlePost'
import pageTemplateContact from './routes/contact'
import pageTemplatePlanning from './routes/planning'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** About Us page, note the change from about-us to aboutUs. */
	pageTemplateAbout,
	/** Locations page */
	locations,
	/** Blog/Category/Posts page */
	blog,
	archive,
	singlePost,
	/** Portfolio page */
	pageTemplatePortfolio,
	/** Services page */
	pageTemplateServices,
	/** Contact page */
	pageTemplateContact,
	/** Planning page */
	pageTemplatePlanning,
})

/** Load Events */
routes.loadEvents()
